export default "__VITE_ASSET__5yeTap5Y__"